<template>
<div class="in-report-manage">
    <component :is="views"></component>
</div>
</template>

<script>
import rsList from '@/views/RSGL/components/rsList';
export default {
    data() {
        return {
            views: rsList
        }
    },
    methods: {},
    mounted() {}
}
</script>
